"use strict";

exports.__esModule = true;
exports.INPUT_TYPES = exports.GALLERY_CONSTS = void 0;

var _index = _interopRequireDefault(require("../../common/constants/index"));

exports.GALLERY_CONSTS = _index["default"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var INPUT_TYPES = {
  NUMBER: "NUMBER",
  BOOLEAN: "BOOLEAN",
  OPTIONS: "OPTIONS",
  TEXT: "TEXT",
  COLOR_PICKER: "COLOR_PICKER",
  FONT_PICKER: "FONT_PICKER",
  BUTTON: "BUTTON",
  MULTISELECT: "MULTISELECT"
};
exports.INPUT_TYPES = INPUT_TYPES;